<template>
  <v-card class="mb-3">
    <v-card-text>
      <div class="subheading">
        {{ $chPtObjData('chinTaskListTitle', activeItem) }}
      </div>
      <div class="grey--text">
        <span v-html="$chPtObjData('chinTaskListDesc1', activeItem)" /><br>
        {{ $chPtObjData('chinTaskListDesc2', activeItem) }}
      </div>
      <div class="float-right">
        <s-class-pdf :url="activeItem.outlineDmsId" />
      </div>
    </v-card-text>

    <v-skeleton-loader
      v-if="loading"
      type="list-item-avatar-two-line, divider, list-item-avatar-two-line"
    />

    <template v-if="!loading">
      <div class="primary--text px-4">
        {{ $t('TaskList.WaitingApproveCount') }} {{ activeItem.numOfApplicants }}
      </div>
      <v-list>
        <template v-for="(staff, index) in staffList">
          <div :key="staff.staffCode">
            <!-- Show only on xsOnly -->
            <!-- <v-list-item
            v-if="$vuetify.breakpoint.xsOnly"
            class="v-list-title--header"
          >
            <v-list-item-content>
              <v-list-item-title>{{ staff.staffChinName }}  {{ staff.staffPortName }}</v-list-item-title>
              <v-list-item-subtitle>
                <div>{{ $t('TrainingClient.EnterCareerDate') }}：{{ momentWithHyphen(staff.enterCareerDate).format('YYYY-MM-DD') }}</div>
                <div
                  v-if="staff.filledIPFormYears"
                  class="mb-3"
                >
                  * {{ $t('Training.BelongTrainingNeed') }}：{{ staff.filledIPFormYears }}{{ $t('Training.YearPeriod') }}
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item> -->

            <v-list-item class="flex-wrap flex-sm-nowrap py-3">
              <!-- Show only on smAndUp -->
              <div
                class="flex-grow-1 flex-shrink-0"
              >
                <v-list-item-title>{{ staff.staffChinName }}  {{ staff.staffPortName }} </v-list-item-title>
                <v-list-item-subtitle>{{ $t('TrainingClient.EnterCareerDate') }}：{{ momentWithHyphen(staff.enterCareerDate).format('YYYY-MM-DD') }}</v-list-item-subtitle>
                <v-list-item-subtitle v-if="staff.filledIPFormYears">
                  * {{ $t('Training.BelongTrainingNeed') }}：{{ staff.filledIPFormYears }}{{ $t('Training.YearPeriod') }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="staff.lastAppraiserStaffCode">
                  {{ $chPtObjData('lastAppraiserChinName', staff) }} {{ $t('TrainingClient.TaskList.Personal1.Agree') }}
                </v-list-item-subtitle>
              </div>

              <div style="width: 60%; max-width: 300px;">
                <v-select
                  v-model="staff.appraiserReasonCode"
                  :items="applyReasons"
                  :item-text="$chPtField('chinDesc')"
                  item-value="code"
                  solo
                  flat
                  hide-details
                />
              </div>

              <div class="flex-grow-0 flex-shrink-1 pl-2">
                <v-tooltip
                  color="black"
                  top
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      :outlined="isApprove(index)"
                      :color="isApprove(index) ? 'success' : null"
                      :disabled="isEndEnrollment"
                      ripple
                      v-on="on"
                      @click="clickStatus(index, 1)"
                    >
                      <v-icon color="success lighten-1">
                        {{ mdiCheck }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('TrainingClient.TaskList.Personal1.Agree') }}</span>
                </v-tooltip>

                <v-tooltip
                  color="black"
                  top
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      :outlined="isDecline(index)"
                      :color="isDecline(index) ? 'error' : null"
                      v-on="on"
                      @click="clickStatus(index, 0)"
                    >
                      <v-icon color="error lighten-1">
                        {{ mdiClose }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('Text.Cancel') }}</span>
                </v-tooltip>

                <!-- <s-transfer-task
                  :task="staff"
                  :disabled="isEndEnrollment"
                  @transfer-task="transferTaskToStaff(staff, $event)"
                /> -->
              </div>
            </v-list-item>

            <v-divider />
          </div>
        </template>
      </v-list>
    </template>

    <v-card-actions>
      <v-btn
        color="primary"
        class="ml-2"
        :disabled="numOfNoStatusStaff > 0 || numOfDeclineStaff === staffList.length || isEndEnrollment"
        :to="`/tasklist/trainingStaffOrder/${courseid}`"
      >
        {{ $t('TaskList.NextStep') }}
      </v-btn>
      <v-btn
        color="primary"
        :disabled="numOfDeclineStaff < staffList.length || staffList.length < 1"
        @click="submitForm"
      >
        {{ $t('Text.Submit') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { mapTaskListMultiRowFields } from '../../../store/modules/training/taskList'
import taskListApi from '../../../api/training/taskList'
import { breakSubErrors } from '../../../utils/messageUtil'
// import { getRootUrl } from '../../../utils/urlUtil'
// import STransferTask from './STransferTask'
import SClassPdf from '../../../components/SClassPdf'
import workflowApi from '../../../api/workflow/workflow'
import { globalModule, workflowModule, trainingTLModule } from '../../../store/moduleName'
import { momentWithHyphen } from '@/utils/datetimeUtil'
import { mdiCheck, mdiClose } from '@mdi/js'

export default {
  components: {
    // STransferTask,
    SClassPdf
  },
  props: {
    courseid: {
      type: String,
      required: true
    }
  },
  data: () => ({
    mdiClose: mdiClose,
    mdiCheck: mdiCheck,
    loading: false
    // pdfUrl: process.env.NODE_ENV === 'production' ? getRootUrl() + '/b2/training/api/tc/pc/public/openOutline/' : 'http://192.168.119.122/b2/training/api/tc/pc/public/openOutline/'
  }),
  computed: {
    ...mapTaskListMultiRowFields({
      staffList: 'proposalClassActiveItems'
    }),
    numOfNoStatusStaff: function () {
      return this.staffList.filter(staff => staff.status === null).length
    },
    numOfDeclineStaff: function () {
      return this.staffList.filter(staff => staff.status === 0).length
    },
    isEndEnrollment: function () {
      return this.staffList.filter(staff => staff.isEndEnrollment === true).length > 0
    },
    // staffList: {
    //   get () {
    //     return this.$store.state.trainingTaskList.proposalClassActiveItems
    //   }
    //   // set (value) {
    //   //   this.$store.commit('trainingTaskList/setProposalClassActiveItems', value)
    //   // }
    // },
    // ...mapMultiRowFields(['trainingTaskList.proposalClassActiveItems']),
    ...mapState(trainingTLModule, {
      applyReasons: state => state.appraiserReasons,
      // staffList: state => state.trainingTaskList.proposalClassActiveItems,
      activeItem: state => state.classSummariesActiveItem
    })
  },
  watch: {
    staffList: function () {
      this.loading = false
    }
  },
  created () {
    this.loading = true
    this.$store.dispatch(trainingTLModule + '/getAppraiserReasons')
    this.$store.dispatch(trainingTLModule + '/getClassSummariesActiveItem', ~~this.courseid)
    this.$store.dispatch(trainingTLModule + '/getProposalClassActiveItems', this.courseid)
    this.$store.dispatch(trainingTLModule + '/getProposalClassHistoryItems', this.courseid)
  },
  methods: {
    clickStatus: function (index, status) {
      this.$store.dispatch(trainingTLModule + '/updateProposalClassActiveItemStatus', { index, status })
      // this.staffList[index].status = status
    },
    isApprove: function (index) {
      return this.staffList[index].status === 1
    },
    isDecline: function (index) {
      return this.staffList[index].status === 0
    },
    submitForm: function () {
      // let finalList = JSON.parse(JSON.stringify(this.$store.state[trainingTLModule].proposalClassActiveItems))
      this.$store.commit(trainingTLModule + '/setFinalItemsByList', this.$store.state[trainingTLModule].proposalClassActiveItems)
      taskListApi.completeTrainingStep(cb => {
        if (cb.status === 201 || cb.status === 200) {
          // alert('successfully!')
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
          this.$router.push({ name: 'tasklist/trainingList' })
        } else {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$chPtObjData('chinMessage', breakSubErrors(cb.data.subErrors)))
        }
      }, JSON.stringify(this.$store.state[trainingTLModule].finalItems))
    },
    transferTaskToStaff: function (task, staffCode) {
      workflowApi.transferTaskToStaff(cb => {
        if (cb.status === 201 || cb.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('TaskList.Transfer.SuccessMessage'))
          this.$store.dispatch(trainingTLModule + '/getProposalClassActiveItems', this.courseid)
          this.$store.dispatch(trainingTLModule + '/getClassSummariesActiveItem', ~~this.courseid)
          this.$store.dispatch(trainingTLModule + '/getProposalClassHistoryItems', this.courseid)
          // this.$store.dispatch(workflowModule + '/getActiveItems', task.formAttribute.businessCode)
          // this.$store.dispatch(workflowModule + '/countItemByBusinessCode', this.businessCode)
          // this.$store.dispatch(workflowModule + '/getMyAttentionStaffs', task.formAttribute.businessCode)
          // this.$store.dispatch(workflowModule + '/countAttentionItems')
          this.$store.dispatch(workflowModule + '/countPersonalItems')
        }
      }, task.workItemId, staffCode, task.newMessage)
    },
    momentWithHyphen: momentWithHyphen
  }
}
</script>

<style scoped>
.v-list-title--header {
  height: 52px;
}

.v-list > div {
  background-color: #f5f5f5;
}
</style>
